export default __webpack_public_path__ + "static/media/1754.6e756d71.png";